import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { useMediaQuery } from '@mantine/hooks';

import { ScrollArea, createStyles, Drawer } from '@mantine/core';

import NavbarContent from './NavbarContent'
import useSidebarStyles from "../../utils/SidebarStyles"
import { setHoverSidebar } from "../../store/app";

const useStyles = createStyles((theme, {spaceView, settingsView, colors}) => ({
  appSideFrame: {
    width: theme.other.sideFrameWidth,
    height: `calc(100vh - ${theme.other.headerHeight}px)`,
    boxSizing: "border-box",
    overflow: "hidden",
    backgroundColor: "#fff",
    borderRight: !spaceView < 0 && !settingsView ? "1px solid #ececec" : "none"
  },
  appSideFrameHover: {
    display: "block",
    width: theme.other.sideFrameWidth,
    height: `calc(100vh - ${theme.other.headerHeight}px)`,
    boxSizing: "border-box",
    overflow: "hidden",
    backgroundColor: "#fff",
    position: "absolute",
    boxShadow: "0px 15px 20px 5px #999",
    zIndex: 299
  },
  drawer: {
    width: theme.other.sideFrameWidth,
    backgroundColor: colors?.sidebar_background_color
  }
}))

export default function Navbar() {
  const dispatch = useDispatch();

  const hiddenSidebar = useSelector(state => state.hiddenSidebar);
  const hoverSidebar = useSelector(state => state.hoverSidebar);
  const colors = useSelector(state => state.colors);

  const { spaceView, settingsView } = useSidebarStyles();
  const { classes, cx, theme } = useStyles({spaceView, settingsView, colors});
  const mediumScreen = useMediaQuery(`(max-width: ${theme.other.breakpoints.md}px)`);

  const isStaticSpaceRoute = () => {
    const path = window.location.pathname;
    const hrefParts = window.location.href.split("/");
  
    const basePaths = ["/space", "/user", "/app/pay"];
    const subPaths = [
      "/register",
      "/registration",
      "/private",
      "/pending",
      "/demo",
      "/pay"
    ];
  
    const containsBase = basePaths.some(p => path.includes(p));
    const containsSub = subPaths.some(p => path.includes(p));
    const isHrefLength5 = hrefParts.length === 5;
  
    return containsBase && (containsSub || isSurvey() || isHrefLength5);
  };

  const alwaysHide = () => {
    const path = window.location.pathname;
  
    return (
      path.includes("/home") ||
      (path.includes("/setting") && !path.includes("/space")) ||
      path.includes("/app") ||
      isSurvey()
    );
  };

  const isSurvey = () => {
    return /(^|\/)survey(\/|$|\?|#)/.test(window.location.pathname);
  };
  
  if ((hiddenSidebar.hidden && !alwaysHide()) || (mediumScreen && !hoverSidebar.hover) || isStaticSpaceRoute()){

    return null
  }

  if (mediumScreen && hoverSidebar.hover) {
    return (
      <Drawer
        opened={true}
        withCloseButton={false}
        styles={{ drawer: classes.drawer }}
        onClose={() => dispatch(setHoverSidebar({ hover: false }))}
      >
        <ScrollArea
          scrollbarSize={12}
          style={{height: "calc(100vh - 60px)", width: theme.other.sideFrameWidth}}
        >
          <NavbarContent />
        </ScrollArea>
      </Drawer>
    );
  } else {
    return (
      <div className={cx(classes.appSideFrame, { [classes.appSideFrameHover]: hoverSidebar.hover })}>
        <ScrollArea
          scrollbarSize={12}
          style={{height: "calc(100vh - 60px)"}}
        >
          <NavbarContent />
        </ScrollArea>
      </div>
    );
  }
}
